import players from '../data/players.js';
import RatingPage from './RatingPage';
import MdgLogo from '../assets/mdg.png'

const MdgRatings = () => {
  return (
    <RatingPage playerData={players}>
      MDG Players <img src={MdgLogo} alt="" />
    </RatingPage>
  );
};

export default MdgRatings;
